// Helfer für guestInfo-Daten aus dem SSE-Stream (QEMU Guest Agent, bis ~5 Min alt).

// „Echte" IPs: ohne Loopback (lo, 127.x, ::1) und ohne Link-Local (fe80::/10, 169.254.x).
export function realGuestIps(guestInfo) {
  const nics = Array.isArray(guestInfo?.nics) ? guestInfo.nics : [];
  const out = [];
  nics.forEach((nic) => {
    if (String(nic?.nicName || '').toLowerCase() === 'lo') return;
    (Array.isArray(nic?.ips) ? nic.ips : []).forEach((ip) => {
      const address = String(ip?.address || '').trim();
      if (!address) return;
      const lower = address.toLowerCase();
      if (lower === '::1' || lower.startsWith('127.')) return;
      if (lower.startsWith('fe8') || lower.startsWith('fe9') || lower.startsWith('fea') || lower.startsWith('feb')) return;
      if (lower.startsWith('169.254.')) return;
      out.push(address);
    });
  });
  return [...new Set(out)];
}

// Lesbares Gast-OS-Label; null, wenn keine Agent-Daten vorhanden.
export function guestOsLabel(guestInfo) {
  const os = guestInfo?.os;
  if (!os) return null;
  const pretty = String(os.prettyName || '').trim();
  if (pretty) return pretty;
  const name = String(os.name || os.id || '').trim();
  const version = String(os.versionId || '').trim();
  return name ? `${name}${version ? ` ${version}` : ''}` : null;
}
